/* eslint-disable max-len, indent, init-declarations, arrow-body-style, react/jsx-indent, react/jsx-indent-props */
import { Image } from "react-bootstrap";
import PropTypes from "prop-types";

import anger from "../assets/icons/angry-face.svg";
import anxiety from "../assets/icons/sad-but-relieved-face.svg";
import dependent from "../assets/icons/dependent.png";
import disconnected from "../assets/icons/disconnected.png";
import fear from "../assets/icons/fearful-face.svg";
import independent from "../assets/icons/independent.png";
import interdependent from "../assets/icons/interdependent.png";
import joy from "../assets/icons/smiling-face.svg";
import love from "../assets/icons/smiling-face-with-hearts.svg";
import sadness from "../assets/icons/disappointed-face.svg";
import shame from "../assets/icons/flushed-face.svg";

const EqqoIcon = ({ height, icon, width }) => {
  const icons = {
    anger,
    anxiety,
    dependent,
    disconnected,
    fear,
    independent,
    interdependent,
    joy,
    love,
    sadness,
    shame
  };

  return (
    <Image
        alt=""
        data-name={icon}
        height={height}
        src={icons[icon]}
        width={width}
    />
  );
};

EqqoIcon.defaultProps = {
  height: 40,
  width: 40
};

EqqoIcon.propTypes = {
  height: PropTypes.number,
	icon: PropTypes.string.isRequired,
  width: PropTypes.number
};

export default EqqoIcon;
